<template>
  <li class="advanced-sort" @click.prevent="openSort">
    <a class="sort-list-btn" href="#" title="進階篩選">
      <span>FILTERS</span>
      <i class="icon-toggle" />
    </a>
  </li>
</template>

<script>
import $ from 'jquery';

export default {
  methods: {
    openSort() {
      $('#lb-sort').toggleClass('active');
      $('.icon-toggle').toggleClass('active');
    },
  },
};
</script>
